module.exports = __webpack_public_path__ + "img/1F3C6.26cfa584.svg";